import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import { loadingKtvAmplifierDataComponent, loadingOpDataComponent } from '../../../LoadingData/LoadingDataComponents';
import { UpdateAmplifierModel, UpdateOpModel } from '../../../UpdateData/UpdateCommunications';
import { DELETE_AMPLIFIER_ID_API_URL, DELETE_OP_ID_API_URL } from '../../../OpticApiConfig';


const OpNodeCantonEditingDialog = ({ open, onClose, content, cantonRefresh}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [opData, setOpData] = useState([]);
  const [opId, setOpId] = useState("");
  const token = localStorage.getItem('token');




  useEffect(() => {
    const fetchData = async () => {
      try {
        const [opData, rankComponentData] = await Promise.all([
          loadingOpDataComponent(),
          //loadingRankComponentDataComponent(),
        ]);
        setOpData(opData);
       // setRankComponentData(rankComponentData);
      } catch (error) {
        // console.error("Error in fetchData:", error);
      }
    };
    fetchData();
  }, []);

  
  const handleCloseDialogs = () => {
    onClose();
  };


   const deleteOp = async () => {
  
          if (!token) {
              showSnackbar('Ошибка! Токен не найден', 'snackbarWarning');
              return;
          }

          try {
              let apiOp = `${DELETE_OP_ID_API_URL}?opId=${content.id}`;

              const response = await fetch(apiOp, { 
                  method: 'DELETE',
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}` 
                  }
              });
  
              if (response.ok) {
                  showSnackbar('Компонент успешно удален', 'snackbarWarning');
                  setOpData([]);
                  setOpId("");
                  cantonRefresh();
                  handleCloseDialogs();
              } else {
                  showSnackbar('Ошибка удаления!', 'snackbarWarning');
              }
          } catch (error) {
              showSnackbar('Произошла ошибка!', 'snackbarWarning');
          }  
      };

  const handleChangeOpSelect = (event) => {
    const selectedOp = event.target.value;
    if (selectedOp === "") {
      setOpId("");
    } else {
      const selectedOp2 = opData.find(op => 
        `${op.id}` === selectedOp
      );
      if (selectedOp2) {
        setOpId(selectedOp2.id);
      }
    }
  };

  const updateModel = () => {
  
    if (opId === "") {
      showSnackbar('Нет нужды в записи, усилитель без изменений!', 'snackbarOk');
    } else {
      UpdateOpModel(content.id, opId, showSnackbar, cantonRefresh );
    } 
  };


    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
    
      <img src='./op.png' width='30' height='30' style={{ marginRight: "5px" }} />
          
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>Редактирование ОП</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe' }}>{content.id}</span></label>
      <br/>
      
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ОП: </label>

      <select className="selectStyleDrawer" 

        onChange={(event) => {
          handleChangeOpSelect(event);
        }} >
        <option value="">{content.model}</option>
        {opData.map(op => (
          <option key={op.id} value={op.id}>{op.model}</option>
        ))}
      </select>
      <button onClick={updateModel} class='buttonIsSaveDialog2'>Сохранить</button>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>

      <button onClick={deleteOp} class='buttonIsDeleteModal2' style={{marginLeft:"0px"}}>Удалить</button>

      {/* <hr className='horizontalLineDialog'/>
      <button  class='buttonIsCoupFobDialog' onClick={openModalConnectionComponents}> Закрепить фоб</button> */}
      

      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>


       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

      
    </Dialog>
  );
}

export default OpNodeCantonEditingDialog;